// extracted by mini-css-extract-plugin
export default {"navigationPath":"NavigationPath_navigationPath__i2VtT","navigationLink":"NavigationPath_navigationLink__Z9R4t","navigationLinkText":"NavigationPath_navigationLinkText__FdaSr"};